import React from "react";
import "./categoryCard.css";
import img from '../../Images/default.png'
import NoData from "../../COMPONENT/NoData";
import { useSelector } from "react-redux"; 
import { useNavigate } from "react-router-dom";

function CategoryCard() {
  const { data, url } = useSelector((state) => state.product);
  function getTotalProductsByCategory(category) {
    return data.products? data.products.filter(product => product.category === category).length : 0;
  }
  const navigate = useNavigate();
  const handleSelectedCategory = (category) => {
    navigate(`/${url}/category/${category.categoryName}/${category._id}`);
  }
  return (
    <>
    {data.categories ? (
      <div className="category-container"> 
        {data.categories.map((category, index) => (
        <div className="category-card" key={index} onClick={()=>handleSelectedCategory(category)}>
          <div className="category-image-container">
          <img
                className="category-image"
                src={
                  category.image
                    ? `${process.env.REACT_APP_CATEGORY_IMAGE_PATH}${category.image}`
                    : img
                }
                alt="Category"
              />
          </div>
          <div className="category-info">
            <div className="category-name">{category.categoryName}</div>
            <div className="product-count">Total choices: {getTotalProductsByCategory(category.categoryName)}</div>
          </div>
        </div>
        ))}
      </div>
      ) : (
        <NoData />
      )}
    </>
  );
}

export default CategoryCard;
